import { render } from "./GroupBuyHome.vue?vue&type=template&id=235ec068&scoped=true"
import script from "./GroupBuyHome.vue?vue&type=script&lang=js"
export * from "./GroupBuyHome.vue?vue&type=script&lang=js"

import "./GroupBuyHome.vue?vue&type=style&index=0&id=235ec068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235ec068"]])

export default __exports__